import script from "./SurveyInvitesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyInvitesTable.vue?vue&type=script&setup=true&lang=js"

import "./SurveyInvitesTable.vue?vue&type=style&index=0&id=7415199d&lang=scss"

const __exports__ = script;

export default __exports__